import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_pejo from "../../assets/img/face_balazs_pejo.jpg";
import ShowMoreText from "react-show-more-text";
import proj_contribution_eval_federated_learning from "../../assets/img/proj_contribution_eval_federated_learning.png";

const Balazs_Pejo_contr_eval_federated = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_contribution_eval_federated_learning} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_pejo}
              /* this will be the text on the banner */
              alt="Contribution Evaluation & Security in Federated Learning"
            />{" "}
            <p className="text7">Balázs Pejó</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">CrySysLab, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Our daily lives are intertwined with computers, enabling companies to collect 
            vast data about us. This led to federated learning (FL), where multiple data 
            holders train a single machine learning model collaboratively. Nevertheless, 
            some may be nefarious and inject a backdoor (unintended malicious behavior) 
            into the model, so finding and mitigating their impact is crucial for integrity 
            and reliability. A similar problem is contribution evaluation (CE), especially 
            if the final model is utilized as a service: how should the participants distribute 
            the obtained gains? A few natural questions arise concerning these directions:
            <ul>
                <li>
                What effect do the security techniques have on the participants' contribution scores?
                </li>
                <li>
                Are the security mechanisms (i.e., flagging bad actors) and contribution score 
                computation methods (i.e., assigning fine-grained scores) interchangeable?
                </li>
            </ul>
            <br />
            <br />

            Related literature:{" "}

            <ul>
                <li>
                Goldblum, Micah, et al. "Dataset security for machine learning: Data poisoning, 
                backdoor attacks, and defenses." IEEE Transactions on Pattern Analysis and 
                Machine Intelligence 45.2 (2022): 1563-1580.
                </li>
                <li>
                Siomos, Vasilis, and Jonathan Passerat-Palmbach. "Contribution Evaluation in 
                Federated Learning: Examining Current Approaches." arXiv preprint arXiv:2311.09856 (2023).
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Pejo_contr_eval_federated;